/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TargetsTarget from './TargetsTarget';

/**
 * The TargetsBody model module.
 * @module model/TargetsBody
 * @version v0.3
 */
export default class TargetsBody {
  /**
   * Constructs a new <code>TargetsBody</code>.
   * @alias module:model/TargetsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TargetsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TargetsBody} obj Optional instance to populate.
   * @return {module:model/TargetsBody} The populated <code>TargetsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TargetsBody();
      if (data.hasOwnProperty('target'))
        obj.target = TargetsTarget.constructFromObject(data['target']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TargetsTarget} target
 */
TargetsBody.prototype.target = undefined;

